module.exports = __webpack_public_path__ + "images/sd-03-faq-desktop.png";